const customStyles = {
    control: (provided) => ({
      ...provided,
      border: '1px solid var(--border-color)',
      borderRadius: '10px',
      boxShadow: 'none',
      backgroundColor: "transparent",
      width: "10vw !important",
      cursor: "pointer",
      marginLeft: '50%',
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='18' height='18'%3E%3Cpath fill='none' d='M0 0h24v24H0z'%3E%3C/path%3E%3Cpath d='M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z' fill='rgba(255,255,255,1)'%3E%3C/path%3E%3C/svg%3E");`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "90%",
      color: "var(--primary-text-color)",
      '&:hover': {
      },
      '@media screen and (max-device-width: 480px) and (orientation: portrait)': {
        width: "25vw !important",
        left: "-30%",
        fontSize: "10px",
        padding: '0px',
        paddingRight: "20px",
        textAlign: "left"
      }
    }),
  
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: "transparent",
      display: "none"
    }),
  
    option: (provided) => ({
      ...provided,
      padding: '2px 10px',
      cursor: "pointer",
      color: "var(--primary-text-color)",
      backgroundColor: "var(--background-color)",
      overflow: "visible",
      zIndex: "2",
      textAlign: "left",
      '@media screen and (max-device-width: 480px) and (orientation: portrait)': {
        fontSize: "10px",
      }
    }),
  
    dropdownIndicator: (styles) => ({
      ...styles,
      display: "none",
    }),
  
    input: (styles) => ({
      ...styles,
      '[type="text"]': {
        color: 'var(--primary-text-color) !important',
        fontWeight: "400",
        fontSize: "16px",
        padding: "0px",
        width: "100px !important"
      }
    }),
  
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        cursor: "pointer",
        fontSize: "16px",
        color: "var(--primary-text-color)",
      };
    },
  
    valueContainer: (provided) => ({
      ...provided,
      color: 'var(--primary-text-color)',
      textAlign: "left"
    }),
  
    singleValue: (provided) => ({
      ...provided,
      color: "var(--primary-text-color)"
    }),
  };
  
  const companyProfileDropdown = {
    control: (styles, state) => ({
      ...styles,
      color: '#fff',
      borderBottom: '2px solid var(--input-field-line-color)',
      flexWrap: 'nowrap',
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      borderRadius: '0px',
      width: '100%',
      cursor: 'pointer',
      backgroundColor: 'transparent',
      boxShadow: state.isFocused && 'none',
      '&:hover': {
        borderBottom: '2px solid var(--input-field-line-color)',
      },
    }),
    option: (provided) => ({
      ...provided,
      cursor: 'pointer',
      color: '#fff',
      backgroundColor: '#111727',
      '&:hover': {
        backgroundColor: '#556EE0',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#fff !important',
      fontFamily: 'var(--font-roboto)',
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
  }
  
  const employeeProfileDropdown = {
    control: (styles, state) => ({
      ...styles,
      color: '#fff',
      borderBottom: '2px solid var(--input-field-line-color)',
      flexWrap: 'nowrap',
      border: '1px solid #fff',
      borderRadius: '6px',
      width: '100%',
      backgroundColor: 'none',
      boxShadow: state.isFocused && 'none',
      padding: '0px 5px'
    }),
    option: (provided) => ({
      ...provided,
      cursor: 'pointer',
      color: '#fff',
      backgroundColor: '#111727',
      '&:hover': {
        backgroundColor: '#556EE0',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#fff !important',
      fontFamily:'var(--font-roboto)',
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
  }
  
  const appStylesSecond = {
    customStyles,
    companyProfileDropdown,
    employeeProfileDropdown
  }
  
  export default appStylesSecond;